import { hsla } from 'polished';
import type { Colors, DefaultTheme } from 'styled-components';
import { setAlpha } from '../utils';
import { lightColors, mapLightTheme } from './LightTheme';

const colors: Colors = {
  gray: {
    main: '#FFFFFF',
    '000': '#F1F1F1',
    '010': '#F8F8F8',
    '020': '#ececec',
    '030': hsla(240, 0.12, 0.91, 1),
    '040': hsla(240, 0.06, 0.85, 1),
    '050': hsla(240, 0.06, 0.81, 1),
    '060': hsla(240, 0.06, 0.77, 1),
    '070': hsla(240, 0.06, 0.73, 1),
    '080': '#193843',
    '090': '#031B23',
    '100': '#031B23',
  },

  black: {
    default: '#000000',
    dim: 'rgba(0, 0, 0, 0.4)',
    mute: 'rgba(0, 0, 0, 0.1)',
  },

  white: {
    default: '#FFFFFF',
    dim: 'rgba(255, 255, 255, 0.4)',
    mute: 'rgba(255, 255, 255, 0.1)',
  },

  primary: {
    mute: setAlpha(0.1, '#29508B'),
    dim: setAlpha(0.4, '#29508B'),
    default: '#29508B',
    lighten: '#3e6196',
  },

  green: {
    mute: setAlpha(0.1, '#5ab548'),
    dim: setAlpha(0.4, '#5ab548'),
    default: '#5ab548',
    lighten: '#64d864',
  },

  red: {
    mute: setAlpha(0.1, '#ca3939'),
    dim: setAlpha(0.4, '#ca3939'),
    default: '#b53333',
    lighten: '#ca3939',
  },

  yellow: {
    mute: setAlpha(0.1, '#F3D900'),
    dim: setAlpha(0.4, '#F3D900'),
    default: '#F3D900',
    lighten: '#F3D900',
  },

  blue: {
    mute: setAlpha(0.1, '#306fb8'),
    dim: setAlpha(0.4, '#306fb8'),
    default: '#306fb8',
    lighten: '#4898F4',
  },

  orange: {
    mute: 'rgba(230, 82, 0, 0.1)',
    dim: 'rgba(230, 82, 0, 0.4)',
    default: '#E65200',
    lighten: '#FF6B00',
  },

  purple: lightColors.purple,
};

export const LightEtanaTheme: DefaultTheme = mapLightTheme(colors, {
  name: 'LightEC',

  fontFamily: "'Poppins', sans-serif",
  fontUrl:
    'https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,400;0,500;0,600;1,400;1,500;1,600&display=swap',

  spacingLayout: 8,

  backgroundInput: colors.gray.main,

  backgroundVolumeLadderBidSpread: colors.primary.default,
  backgroundVolumeLadderOfferSpread: colors.primary.default,
});
